export const projects = [
  {
    slug: 'eden-pacs',
    company: 'Eden',
    title: 'PET-CT & Cardio PACS',
    period: '2025 – presente',
    desc: 'Herramientas de visualización médica de alta especialidad. Prototipos interactivos en Figma Make con datos reales del mundo clínico.',
    longDesc: 'Diseño de interfaces PACS (Picture Archiving and Communication System) para PET-CT y Cardiología. Herramientas de alta complejidad que permiten a especialistas navegar, anotar y diagnosticar a partir de imágenes médicas de alta resolución.',
    tags: ['Medical imaging', 'Figma Make'],
    role: 'Senior Product Designer',
    impact: 'En curso',
    stack: 'Figma Make · DICOM',
    accent: 'var(--milo-steel)',
    accentBg: 'oklch(0.96 0.025 245)',
    visualBg: 'linear-gradient(135deg, oklch(0.96 0.025 245) 0%, oklch(0.92 0.05 245) 100%)',
    wide: false,
    highlights: [
      { label: 'Rol', value: 'Senior Product Designer' },
      { label: 'Duración', value: '2025 – presente' },
      { label: 'Equipo', value: 'Imaging · Ingeniería' },
      { label: 'Impacto', value: 'En curso' }
    ]
  },
  {
    slug: 'eden-ai-report',
    company: 'Eden',
    title: 'Eden AI Report',
    period: '2024 – presente',
    desc: 'Sistema de reportes médicos impulsados por IA para radiología clínica. Diseñé flujos de lectura, estructuras de hallazgos y entrega final con ingeniería.',
    longDesc: 'Eden AI Report es una herramienta de generación automatizada de informes radiológicos que usa modelos de lenguaje para asistir al radiólogo en la redacción estructurada. Diseñé el flujo completo: desde la lectura del estudio hasta la validación, firma y entrega del reporte al médico tratante.',
    tags: ['Healthtech', 'AI', 'B2B'],
    role: 'Senior Product Designer',
    impact: 'En curso',
    stack: 'Figma Make · AI',
    accent: 'var(--milo-terra)',
    accentBg: 'oklch(0.96 0.025 45)',
    visualBg: 'linear-gradient(135deg, oklch(0.96 0.025 45) 0%, oklch(0.92 0.05 45) 100%)',
    wide: true,
    highlights: [
      { label: 'Rol', value: 'Senior Product Designer' },
      { label: 'Duración', value: '2024 – presente' },
      { label: 'Equipo', value: 'Product · Tech · Radiología' },
      { label: 'Impacto', value: 'En curso' }
    ]
  },
  {
    slug: 'lahaus-investors',
    company: 'La Haus',
    title: 'Plataforma de inversión inmobiliaria',
    period: '2018 – 2024',
    desc: 'De cero al 67% de ingresos. Flujo completo para comprar una propiedad en línea — desde búsqueda hasta firma digital, construido con Design Sprints.',
    longDesc: 'Lideré el diseño de la plataforma de lanzamientos inmobiliarios de La Haus, que creció hasta representar el 67% de los ingresos de la empresa. Partimos de cero, validamos con usuarios reales y construimos iteración a iteración junto al equipo de producto y tecnología.',
    tags: ['Proptech', 'Lead Designer', 'Design Ops'],
    role: 'Product Designer → Lead',
    impact: '67% revenue',
    stack: 'Figma · Design Ops · ProtoPie',
    accent: 'var(--milo-indigo)',
    accentBg: 'oklch(0.96 0.025 280)',
    visualBg: 'linear-gradient(135deg, oklch(0.96 0.025 280) 0%, oklch(0.92 0.05 280) 100%)',
    wide: false,
    highlights: [
      { label: 'Rol', value: 'Lead Product Designer' },
      { label: 'Duración', value: '2018 – 2024 · 6.5 años' },
      { label: 'Equipo', value: 'PM · Data · Tech · Design' },
      { label: 'Impacto', value: '67% de los ingresos' }
    ]
  },
  {
    slug: 'lahaus-golden-path',
    company: 'La Haus',
    title: 'Golden Path con IA',
    period: '2023 – 2024',
    desc: 'Rediseño del flujo principal integrando IA para recomendación personalizada. Primer proyecto de IA en el producto, liderado desde diseño.',
    longDesc: 'Lideré el rediseño del flujo principal de búsqueda y compra de La Haus integrando capacidades de IA. El proyecto implicó definir la estrategia de personalización, diseñar los nuevos flujos conversacionales y coordinar la entrega con el equipo de ingeniería de IA.',
    tags: ['AI', 'UX Strategy', 'Systems'],
    role: 'Lead Product Designer',
    impact: 'Flujo principal rediseñado',
    stack: 'Figma · Design Ops',
    accent: 'var(--milo-forest)',
    accentBg: 'oklch(0.96 0.025 165)',
    visualBg: 'linear-gradient(135deg, oklch(0.96 0.025 165) 0%, oklch(0.92 0.05 165) 100%)',
    wide: false,
    highlights: [
      { label: 'Rol', value: 'Lead Product Designer' },
      { label: 'Duración', value: '2023 – 2024' },
      { label: 'Equipo', value: 'AI · Product · Tech' },
      { label: 'Impacto', value: 'Core flow rediseñado' }
    ]
  },
  {
    slug: 'grandpa-freelance',
    company: 'Grandpa · Freelance',
    title: 'Portafolio multi-industria',
    period: '2015 – 2018',
    desc: 'Productos para GHIX (Suiza), Urgencias.red, HolaDr, Raliz, Hoy Reservas. 8+ productos en industrias de salud, hospitality y fintech.',
    longDesc: 'Tres años trabajando como diseñador freelance a través de la agencia Grandpa, diseñando productos digitales para clientes en Colombia, LATAM y Europa. Cada proyecto fue una oportunidad de aprender un nuevo dominio, adaptarme a equipos distribuidos y entregar con estándares internacionales.',
    tags: ['Freelance', 'Multi-industria', '8+ productos'],
    role: 'UI Designer · Freelance',
    impact: '8+ productos lanzados',
    stack: 'Sketch · InVision · Figma',
    accent: 'var(--milo-amber)',
    accentBg: 'oklch(0.96 0.025 75)',
    visualBg: 'linear-gradient(135deg, oklch(0.96 0.025 75) 0%, oklch(0.92 0.05 75) 100%)',
    wide: false,
    highlights: [
      { label: 'Rol', value: 'UI Designer · Freelance' },
      { label: 'Duración', value: '2015 – 2018 · 3 años' },
      { label: 'Clientes', value: 'GHIX · HolaDr · Raliz' },
      { label: 'Impacto', value: '8+ productos lanzados' }
    ]
  },
  {
    slug: 'cottz',
    company: 'Cottz',
    title: 'Plataforma de cotizaciones hospitalarias',
    period: '2014 – 2018',
    desc: 'Co-fundé y diseñé una solución que redujo el proceso de cotización de 2 semanas a 1–2 días. Desarrollado en MeteorJS.',
    longDesc: 'Cottz nació de un problema real: los hospitales tardaban semanas en conseguir cotizaciones de insumos médicos. Co-fundé la startup con amigos desarrolladores, lideré el diseño del producto y también participé en el desarrollo frontend. Fue mi primera experiencia end-to-end como founder-designer.',
    tags: ['Startup', 'Co-founder', 'Healthtech'],
    role: 'Co-fundador · Designer',
    impact: '2 semanas → 1–2 días',
    stack: 'MeteorJS · UI',
    accent: 'var(--milo-forest)',
    accentBg: 'oklch(0.96 0.025 165)',
    visualBg: 'linear-gradient(135deg, oklch(0.96 0.025 165) 0%, oklch(0.92 0.05 165) 100%)',
    wide: false,
    highlights: [
      { label: 'Rol', value: 'Co-fundador · Designer' },
      { label: 'Duración', value: '2014 – 2018 · 4 años' },
      { label: 'Equipo', value: 'Founders · Hospitales' },
      { label: 'Impacto', value: '2 semanas → 1–2 días' }
    ]
  }
];

export function getProject(slug) {
  return projects.find(p => p.slug === slug) || null;
}
